export const version = '3.781.0-SNAPSHOT'
